class VerticalTeamComponentFilter {
    constructor(el) {
        this.el = el;
        //This is because the team component can be used in multiple places
        //And we need to filter the members in each instance
        this.members = Array.from(document.querySelectorAll('[data-member-name]'));
        this.filterInput = this.el.querySelector('[type=search]');
        this.clearButton = this.el.querySelector('.search-field__x');
        this.roleFilter = this.el.querySelector('[data-role-filter]');
        this.filteredMembers = [...this.members];
        this.noResultsMessage = this.el.querySelector('.search-no-results');

        this.init();
    }

    init() {
        if (this.filterInput) {
            this.filterInput.addEventListener('input', event => {
                requestAnimationFrame(() => this.filterMembers(event));
                this.toggleClearButton();
            });
        }

        if (this.clearButton) {
            this.clearButton.addEventListener('click', () => {
                this.filterInput.value = '';
                this.filterMembers();
                this.toggleClearButton();
            });
        }

        if (this.roleFilter) {
            this.roleFilter.querySelectorAll('[data-member-role]').forEach(roleElement => {
                roleElement.addEventListener('click', event => {
                    event.preventDefault();
                    this.roleFilter.querySelector('a[data-select]').textContent = event.target.textContent;
                    this.roleFilter.querySelector('a[data-select]').setAttribute('data-member-role', event.target.getAttribute('data-member-role'));
                    this.filterMembers();
                });
            });

            this.roleFilter.querySelector('[data-member-role=""]').addEventListener('click', event => {
                event.preventDefault();
                this.roleFilter.querySelector('a[data-select]').textContent = event.target.textContent;
                this.roleFilter.querySelector('a[data-select]').setAttribute('data-member-role', '');
                this.filterMembers();
            });
        }
    }

    filterMembers(event) {
        const filterText = this.filterInput ? this.filterInput.value.toLowerCase() : '';
        const selectedRole = this.roleFilter ? this.roleFilter.querySelector('a[data-select]').getAttribute('data-member-role') : '';

        this.filteredMembers = this.members.filter(member => this.isMemberMatch(member, filterText, selectedRole));
        this.updateMemberVisibility();
    }

    isMemberMatch(member, filterText, selectedRole) {
        const memberName = member.getAttribute('data-member-name').toLowerCase();
        const memberRole = member.getAttribute('data-member-role');

        const isRoleMatch = !selectedRole || selectedRole === '' || memberRole === selectedRole;
        const isTextMatch = !filterText || memberName.includes(filterText);

        return isRoleMatch && isTextMatch;
    }

    updateMemberVisibility() {
        this.members.forEach(member => {
            const isMatch = this.filteredMembers.includes(member);
            member.style.display = isMatch ? '' : 'none';
        });

        if (this.filteredMembers.length === 0) {
            this.noResultsMessage.style.display = 'block';
        } else {
            this.noResultsMessage.style.display = 'none';
        }
    }

    toggleClearButton() {
        if (this.filterInput.value === '') {
            this.clearButton.style.display = 'none';
        } else {
            this.clearButton.style.display = 'inline';
        }
    }
}

export default VerticalTeamComponentFilter;
